export default {
    namespaced: true,

    state: {
        hourly: {},
        baseline: {},
        raw: {}
    },

    getters: {
        report: (state) => (device) => {
            return state.hourly[device.hash];
        },

        baseline: (state) => (device) => {
            return state.baseline[device.hash];
        }
    },

    mutations: {
        setHourlyReport(state, data) {
            Vue.set(state.hourly, data.hash, data);
            state.hourly[data.hash] = data;
        },

        setBaseline(state, {device, baseline}) {
            Vue.set(state.baseline, device.hash, baseline)
        },
    },

    actions: {
        async getHourlyReport({commit}, {device, fields, filters}) {
            let readings;
            let baseline;
            const promises = [];

            promises.push(window.axios.get(route('api.v2.team.device.report.readings', {
                device: device.hash,
                fields: fields,
                filters: filters
            })).then(({data}) => {
                readings = data.data;
            }));

            promises.push(window.axios.get(route('api.v1.team.device.get', {
                device: device.hash,
            })).then(({data}) => {
                baseline = data.device.baseline;
            }));

            await Promise.all(promises);


            commit('setHourlyReport', {
                hash: device.hash,
                readings
            })

            commit('setBaseline', {
                device,
                baseline
            })
        },

        getBaselineReadings({commit}, {device}) {
            return new Promise((resolve) => {
                return window.axios.get(route('api.v1.team.device.get', {
                    device: device.hash
                })).then(({data})=> {
                    commit('setBaselineReadings', {
                        hash: device.hash,
                        baseline: data.baseline
                    })
                })
            });
        }
    }
}
